import { TooltipDirective } from '../../../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../../../componentes/botones';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { ContentCardComponent } from '../../../../../../componentes/content-card/content-card.component';
import { EmptyStateComponent } from '../../../../../../componentes/empty-state/empty-state.component';
import { ButtonComponent } from '../../../../../../auxiliares/button/button.component';
import { CardColor } from '../../../../../../componentes/componentes.interfaces';

export interface IDataListColumn {
  label: string;
  field?: string;
  template?: TemplateRef<unknown>;
  width?: string;
}

@Component({
  selector: 'app-data-list',
  standalone: true,
  imports: [TooltipDirective, BOTONES, 
    CommonModule,
    MatIconModule,
    DragDropModule,
    ContentCardComponent,
    EmptyStateComponent,
    ButtonComponent,
  ],
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
})
export class DataListComponent {
  @Input() title = 'Lista';
  @Input() icon = 'list';
  @Input() color: CardColor = 'blue';
  @Input() items: unknown[] = [];
  @Input() columns: IDataListColumn[] = [];
  @Input() addButtonText = 'Agregar';
  @Input() emptyMessage = 'No hay elementos configurados';
  @Input() emptyIcon = 'inbox';
  @Input() draggable = false;
  @Input() showCard = true;

  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() dropped = new EventEmitter<CdkDragDrop<unknown[]>>();

  getValue(item: unknown, field: string): string {
    if (!field) return '';
    const keys = field.split('.');
    let value: unknown = item;
    for (const key of keys) {
      if (value && typeof value === 'object') {
        value = (value as Record<string, unknown>)[key];
      } else {
        return '';
      }
    }
    return value !== null && value !== undefined ? String(value) : '';
  }

  onDrop(event: CdkDragDrop<unknown[]>): void {
    this.dropped.emit(event);
  }

  onAdd(): void {
    this.add.emit();
  }

  onEdit(index: number): void {
    this.edit.emit(index);
  }

  onDelete(index: number): void {
    this.delete.emit(index);
  }
}
